// packages
import axios from 'axios';
// services
import { getApolloHeaders, getAppConfig, getSessionItem, setSessionItem, } from './application.service';
import { validateTokens } from './auth.service';
const { environment } = getAppConfig();
const axiosInstance = axios.create({
    baseURL: environment.apiUrl,
    method: 'POST',
    headers: {
        'Content-Type': 'application/json',
        ...getApolloHeaders(),
    },
});
const addAuthHeaders = async (request) => {
    const token = getSessionItem('token');
    const refreshToken = getSessionItem('refreshToken');
    const { token: updatedToken, refreshToken: updatedRefreshToken } = await validateTokens(token, refreshToken);
    setSessionItem('token', updatedToken);
    setSessionItem('refreshToken', updatedRefreshToken);
    request.headers.Authorization = `Bearer ${updatedToken}`;
    request.headers = {
        ...request.headers,
        ...getApolloHeaders(),
    };
    return request;
};
const sessionErrorInterceptor = async (error, navigate) => {
    if (error.message === 'expired-session') {
        navigate('/session-expired');
    }
    return Promise.reject(error);
};
export const fetchData = async (query, variables) => {
    try {
        const { data: { data, errors }, } = await axios.request({ data: { query, variables } });
        if (errors) {
            return { error: JSON.stringify(errors[0].extensions.response) };
        }
        return data;
    }
    catch (err) {
        if (err instanceof Error) {
            return { error: err.message };
        }
    }
};
export const initAxios = (navigate) => {
    axios.defaults.baseURL = environment.apiUrl;
    axios.defaults.method = 'POST';
    axios.defaults.headers.post['Content-Type'] = 'application/json';
    axios.interceptors.request.use((request) => addAuthHeaders(request), (error) => sessionErrorInterceptor(error, navigate));
    axios.interceptors.response.use((response) => response, (error) => sessionErrorInterceptor(error, navigate));
};
export default axiosInstance;
